import { IdentityProviderInfo } from "./identity-provider-info.model";
import { LoginOption } from "./login-option.model";
import { ServerVersion } from "./server-version.model";

export class LoginConfig {
  version: ServerVersion;
  registrationEnabled: boolean;
  enterpriseUseCase: boolean;
  portalEnabled: boolean;
  loginOption: LoginOption;
  identityProviderInfos: IdentityProviderInfo[] = [];
  
    constructor(config: config.LoginConfig) {
      this.version = new ServerVersion(config.ServerVersion);
      this.registrationEnabled = config.RegistrationEnabled;
      this.enterpriseUseCase = config.EnterpriseUseCase;
      this.portalEnabled = config.PortalEnabled;
      this.loginOption = config.LoginOption;
      this.identityProviderInfos = config.IdentityProviderInfos.map(idpInfo => new IdentityProviderInfo(idpInfo));
    }
}
